var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeoplePin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 793.7 793.7",
    style: {
      enableBackground: "new 0 0 793.7 793.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M185.5,175.4c-66.4,0-120.3,53.8-120.3,120.3c0,9.5,7.7,17.2,17.2,17.2h206.2c9.5,0,17.2-7.7,17.2-17.2 C305.8,229.2,251.9,175.4,185.5,175.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 3.2227 152.3493)",
    cx: 185.5,
    cy: 72.3,
    rx: 68.7,
    ry: 68.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.9,3.6c-38,0-68.7,30.8-68.7,68.7c0,27.4,16,51,39.1,62v655.8h59.2V134.3c23.1-11.1,39.1-34.7,39.1-62 C465.6,34.3,434.8,3.6,396.9,3.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplePin);
export default __webpack_public_path__ + "static/media/peoplePin.e7ac2049ad4f2764dac441a331237beb.svg";
export { ForwardRef as ReactComponent };